import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  AxiomLogo,
  Button,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  PageContext,
  Paragraph,
  SmallHeader,
} from '@axiom/ui';

import { WindowUtil } from '../../utils/WindowUtil';
import { DefaultLayout } from '../../layouts/DefaultLayout/DefaultLayout';
import YieldSignSvgUrl from '../../public/svg/yield-sign.svg?url';

const { getUrlWithRelayState } = WindowUtil;

export type ExpiredLinkProps = {
  name?: string;
};

export const ExpiredLink = ({ name = 'EXPIRED_LINK' }: ExpiredLinkProps) => {
  const { setTitle } = useContext(PageContext);
  const location = useLocation();
  const path = '/';
  const loginScreen = getUrlWithRelayState(path, {
    location,
  });

  useEffect(() => {
    setTitle('Axiom Law - Expired Link');
  }, [setTitle]);

  return (
    <DefaultLayout sideImageUrl={YieldSignSvgUrl} name={name}>
      <Grid centered>
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={9} mobileWidth={12}>
            <Gutter bottom="24px" className="text-align-center">
              <AxiomLogo width="230px" />
            </Gutter>
            <Gutter bottom="24px">
              <SmallHeader>Expired Link</SmallHeader>
            </Gutter>
            <Paragraph>
              That link has expired or has already been used. Please use the
              option below to restart the sign in process.
            </Paragraph>

            <Gutter bottom="24px" />
            <Button name="back-button" to={loginScreen} fluid>
              Back to Sign In
            </Button>
          </GridColumn>
        </GridRow>
      </Grid>
    </DefaultLayout>
  );
};
